import React, { useEffect, useState } from 'react';
import { ArrowDownRightIcon, MapPinIcon } from 'lucide-react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
const metrics = [['12,482', 'EXPERIENCES'], ['8,721', 'PRODUCTS CAUGHT'], ['72%', 'REDEMPTION'], ['4.6', 'EXPERIENCE SCORE']];
export function Hero() {
  const [showTurn, setShowTurn] = useState(false);
  const reduceMotion = useReducedMotion();
  useEffect(() => {
    if (reduceMotion) {
      setShowTurn(true);
      return;
    }
    const timer = window.setTimeout(() => setShowTurn(true), 1400);
    return () => window.clearTimeout(timer);
  }, [reduceMotion]);
  return <section id="top" className="poster-rules relative isolate min-h-screen overflow-hidden bg-[#f7f5ef] pt-20" aria-labelledby="hero-heading" data-id="element-460">
      <div className="pointer-events-none absolute left-0 top-[51%] h-px w-[55%] bg-[#ff4d17]/50" data-id="element-461" />
      <div className="relative mx-auto flex min-h-[calc(100vh-5rem)] max-w-[1440px] flex-col justify-center px-5 py-16 md:px-10" data-id="element-462">
        <div className="relative z-10 max-w-[1050px]" data-id="element-463">
          <motion.p initial={reduceMotion ? false : {
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-xs font-extrabold tracking-[0.16em] text-black/50" data-id="element-464">
            THE PRODUCT EXPERIENCE PLATFORM
          </motion.p>

          <h1 id="hero-heading" className="mt-7 font-display text-[clamp(3.9rem,9.6vw,9rem)] font-bold leading-[0.83] tracking-[-0.075em]" data-id="element-465">
            <AnimatePresence mode="wait" data-id="element-466">
              {showTurn ? <motion.span key="turn" initial={reduceMotion ? false : {
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              ease: [0.22, 1, 0.36, 1]
            }} className="block text-[#ff4d17]" data-id="element-467">
                  <span className="block" data-id="element-468">We turn</span>
                  <span className="block pl-[8vw] md:pl-[15vw]" data-id="element-469">
                    brands into
                  </span>
                  <span className="block" data-id="element-470">them.</span>
                </motion.span> : <motion.span key="interrupt" exit={{
              opacity: 0,
              y: -16
            }} transition={{
              duration: 0.28
            }} className="block" data-id="element-471">
                  <span className="block" data-id="element-472">Advertising</span>
                  <span className="block pl-[5vw] md:pl-[11vw]" data-id="element-473">
                    interrupts
                  </span>
                  <span className="block" data-id="element-474">experiences.</span>
                </motion.span>}
            </AnimatePresence>
          </h1>

          <motion.div initial={reduceMotion ? false : {
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: reduceMotion ? 0 : 0.25
        }} className="mt-10 max-w-xl" data-id="element-475">
            <p className="text-lg leading-relaxed text-black/65 md:text-xl" data-id="element-476">
              Sampler turns physical products into interactive consumer
              experiences designed to be targeted, scalable and measurable.
            </p>
            <div className="mt-7 flex flex-col gap-3 sm:flex-row" data-id="element-477">
              <a href="#start" className="inline-flex min-h-14 items-center justify-center gap-2 rounded-full bg-black px-6 text-sm font-extrabold tracking-[0.03em] text-white hover:bg-black/80" data-id="element-478">
                START A CAMPAIGN <ArrowDownRightIcon size={17} data-id="element-479" />
              </a>
              <a href="#platform" className="inline-flex min-h-14 items-center justify-center rounded-full border border-black/25 px-6 text-sm font-bold hover:border-black" data-id="element-480">
                EXPLORE THE PLATFORM
              </a>
            </div>
            <p className="mt-7 text-xs font-bold tracking-[0.08em] text-black/45" data-id="element-481">
              REAL PRODUCTS. REAL PEOPLE. REAL EXPERIENCES. REAL FEEDBACK.
            </p>
          </motion.div>
        </div>

        <HeroPhone data-id="element-482" />
        <ProductObject className="right-[8%] top-[17%] hidden md:block" type="can" label="SODA" data-id="element-483" />
        <ProductObject className="right-[4%] bottom-[19%] hidden lg:block" type="bar" label="CHOCOLATE" data-id="element-484" />
        <ProductObject className="left-[6%] bottom-[20%] hidden md:block" type="shoe" label="SNEAKER" data-id="element-485" />
        <ProductObject className="right-[30%] top-[19%] hidden xl:block" type="burger" label="BURGER" data-id="element-486" />

        <div className="absolute right-5 top-[57%] hidden grid-cols-2 gap-2 lg:grid" data-id="element-487">
          {metrics.map(([value, label], index) => <motion.div key={label} initial={reduceMotion ? false : {
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: reduceMotion ? 0 : 0.55 + index * 0.08
        }} className="w-36 border border-black/15 bg-[#f7f5ef] p-3" data-id="element-488">
              <p className="font-display text-2xl font-bold" data-id="element-489">{value}</p>
              <p className="mt-1 text-[9px] font-extrabold tracking-[0.1em] text-black/45" data-id="element-490">
                {label}
              </p>
            </motion.div>)}
          <p className="col-span-2 mt-1 text-right text-[8px] font-bold tracking-[0.1em] text-black/40" data-id="element-491">
            ILLUSTRATIVE CAMPAIGN DATA
          </p>
        </div>
      </div>
    </section>;
}
function HeroPhone() {
  const reduceMotion = useReducedMotion();
  return <motion.div initial={reduceMotion ? false : {
    opacity: 0,
    y: 44,
    rotate: 4
  }} animate={{
    opacity: 1,
    y: 0,
    rotate: 0
  }} transition={{
    duration: 0.7,
    delay: reduceMotion ? 0 : 0.35,
    ease: [0.22, 1, 0.36, 1]
  }} className="relative z-20 mx-auto mt-12 w-[260px] rounded-t-[42px] border-[7px] border-[#11110f] bg-[#062c50] p-2 shadow-[16px_-16px_0_#ff4d17] md:absolute md:bottom-0 md:right-[11%] md:mt-0" data-id="element-492">
      <div className="min-h-[390px] rounded-t-[30px] bg-[#0b4272] p-4 text-white" data-id="element-493">
        <div className="mx-auto h-5 w-20 rounded-full bg-[#11110f]" data-id="element-494" />
        <p className="mt-7 text-xs font-bold tracking-[0.12em] text-[#72c7e8]" data-id="element-495">
          GONE FISHING
        </p>
        <p className="mt-2 font-display text-3xl font-bold leading-none" data-id="element-496">
          Something big is swimming nearby.
        </p>
        <div className="mt-8 flex h-44 items-center justify-center rounded-[24px] border border-[#72c7e8]/40 water-lines" data-id="element-497">
          <motion.span animate={reduceMotion ? undefined : {
          y: [-6, 6, -6]
        }} transition={{
          duration: 3,
          repeat: Infinity
        }} className="grid h-14 w-14 place-items-center rounded-full bg-[#ff4d17]" data-id="element-498">
            <MapPinIcon size={24} data-id="element-499" />
          </motion.span>
        </div>
        <div className="mt-5 flex items-center justify-between text-xs" data-id="element-500">
          <span data-id="element-501">2.4 KM AWAY</span>
          <span className="rounded-full bg-[#72c7e8] px-2 py-1 font-bold text-[#062c50]" data-id="element-502">
            CAST
          </span>
        </div>
      </div>
    </motion.div>;
}
function ProductObject({
  className,
  type,
  label
}: {
  className: string;
  type: 'can' | 'bar' | 'shoe' | 'burger';
  label: string;
}) {
  const reduceMotion = useReducedMotion();
  const shapes = {
    can: 'h-24 w-12 rounded-[14px] border-4 border-black bg-[#ff4d17]',
    bar: 'h-12 w-28 rounded-sm border-4 border-black bg-[#f3c64b]',
    shoe: 'h-14 w-28 rounded-[60%_20%_30%_15%] border-4 border-black bg-white',
    burger: 'h-16 w-20 rounded-[50%_50%_28%_28%] border-4 border-black bg-[#f3c64b]'
  };
  return <motion.div animate={reduceMotion ? undefined : {
    y: [0, -11, 0],
    rotate: [-4, 4, -4]
  }} transition={{
    duration: 4.5,
    repeat: Infinity,
    ease: 'easeInOut'
  }} className={`absolute z-10 ${className}`} data-id="element-503">
      <div className={`${shapes[type]} shadow-[7px_7px_0_#11110f]`} data-id="element-504" />
      <p className="mt-3 text-center text-[9px] font-extrabold tracking-[0.14em] text-black/55" data-id="element-505">
        {label}
      </p>
    </motion.div>;
}